import * as React from 'react'
import { ChangeEvent } from 'react'

import { useTheme } from '@mui/material/styles'

import { SettingCardExamples } from '@user/components/Settings/EntityFormSettings/FieldSettingsCard/SettingCardExamples'
import { SettingCardOptions } from '@user/components/Settings/EntityFormSettings/FieldSettingsCard/SettingCardOptions'
import { OppStageIndicatorTypes } from '@user/components/Settings/EntityFormSettings/FieldSettingsCard/typings'
import type { IEntityFormSetting } from '@user/store/entityFormSettings/typings'

import { getStyles } from './styling'
import type { FieldOption } from './typings'

interface OpportunityStageFieldProps {
  settingItem: IEntityFormSetting
  titleValue?: string
  settingOptions: FieldOption[]
  onChangeOption: (event: ChangeEvent<HTMLInputElement>, value: string) => void
  isTidalThemeActive: boolean
}

/**
 * The Opportunity Stage field's own settings UI, letting an admin choose
 * between the dropdown and progress-meter display modes.
 *
 * Selected by the registry's `opportunityStage` renderer. The selectable
 * options are supplied by the caller rather than declared here, so the display
 * modes stay defined in one place. Indentation of the option list differs by
 * theme and is resolved through `getStyles`.
 */
export function OpportunityStageField(props: OpportunityStageFieldProps) {
  const {
    settingItem,
    titleValue,
    settingOptions,
    onChangeOption,
    isTidalThemeActive,
  } = props
  const theme = useTheme()
  const styles = getStyles(theme, isTidalThemeActive)

  return (
    <>
      <SettingCardOptions
        value={settingItem.options || OppStageIndicatorTypes.meter}
        title={titleValue}
        onChangeOption={onChangeOption}
        options={settingOptions}
        marginLeft={styles.props.opportunityStageMarginLeft}
        isTidalThemeActive={isTidalThemeActive}
      />
      <SettingCardExamples isTidalThemeActive={isTidalThemeActive} />
    </>
  )
}
